const SALES_PROSPECTING_TYPES = [{
  label: 'Cold Calling',
  value: 1,
  key: 1,
  icon: 'TaskFilled', // Communication action
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Cold Emailing',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Messaging / communication
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'LinkedIn Outreach',
  value: 3,
  key: 3,
  icon: 'FeatureRequestFilled', // Outreach/connection intent
  color: '#1565c0',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'Lead Research',
  value: 4,
  key: 4,
  icon: 'BugFilled', // Investigative action
  color: '#2e7d32',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Lead Scoring',
  value: 5,
  key: 5,
  icon: 'ImprovementsFilled', // Evaluation/adjustment
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Intro Meeting',
  value: 6,
  key: 6,
  icon: 'SupportFilled', // One-on-one session
  color: '#00897b',
  background: 'rgba(178,223,219,0.16)'
}];
const SALES_SERVICE_TYPES = [{
  label: 'Onboarding Kickoff',
  value: 1,
  key: 1,
  icon: 'EpicFilled', // Major starting point
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Training Session',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Informational/educational
  color: '#5e35b1',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Issue Handling',
  value: 3,
  key: 3,
  icon: 'BugFilled',
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Renewal Planning',
  value: 4,
  key: 4,
  icon: 'TaskFilled',
  color: '#2e7d32',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Usage Review',
  value: 5,
  key: 5,
  icon: 'ImprovementsFilled', // Audit / analyze usage
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Client Feedback',
  value: 6,
  key: 6,
  icon: 'FeatureRequestFilled', // Feedback / input
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}];
const SALES_PIPELINE_TYPES = [{
  label: 'Qualification',
  value: 1,
  key: 1,
  icon: 'SubtaskFilled', // Early stage filtering
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'Deal Creation',
  value: 2,
  key: 2,
  icon: 'TaskFilled',
  color: '#455a64',
  background: 'rgba(176,190,197,0.16)'
}, {
  label: 'Proposal Sent',
  value: 3,
  key: 3,
  icon: 'StoryFilled',
  color: '#fbc02d',
  background: 'rgba(255,249,196,0.16)'
}, {
  label: 'Negotiation',
  value: 4,
  key: 4,
  icon: 'ChangerequestFilled', // Back-and-forth action
  color: '#d84315',
  background: 'rgba(255,204,188,0.16)'
}, {
  label: 'Contract Sent',
  value: 5,
  key: 5,
  icon: 'FeatureRequestFilled',
  color: '#8e24aa',
  background: 'rgba(225,190,231,0.16)'
}, {
  label: 'Closed Won/Lost',
  value: 6,
  key: 6,
  icon: 'EpicFilled', // Major resolution point
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}];


export {
  SALES_PROSPECTING_TYPES,
  SALES_SERVICE_TYPES,
  SALES_PIPELINE_TYPES
};
